import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Produtos from "./pages/Produtos";
import Solucoes from "./pages/Solucoes";
import Precos from "./pages/Precos";
import Integracoes from "./pages/Integracoes";
import Sobre from "./pages/Sobre";
import Contato from "./pages/Contato";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Ajuda from "./pages/Ajuda";
import CalculadoraRoi from "./pages/CalculadoraRoi";
import Desenvolvedores from "./pages/Desenvolvedores";
import ApiDocs from "./pages/ApiDocs";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produtos" element={<Produtos />} />
          <Route path="/solucoes" element={<Solucoes />} />
          <Route path="/precos" element={<Precos />} />
          <Route path="/integracoes" element={<Integracoes />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/ajuda" element={<Ajuda />} />
          <Route path="/calculadora-roi" element={<CalculadoraRoi />} />
          <Route path="/desenvolvedores" element={<Desenvolvedores />} />
          <Route path="/desenvolvedores/docs" element={<ApiDocs />} />
          <Route path="/termos" element={<Legal kind="termos" />} />
          <Route path="/privacidade" element={<Legal kind="privacidade" />} />
          <Route path="/entrar" element={<Login />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
